import { Socket, io } from "socket.io-client";
import React, { ReactNode, createContext, useContext, useEffect, useRef, useState } from "react";
import sound from '../../assets/sound/message_sound.mp3'

export type IWebSocketContext = {
    socket: Socket | null;
};

const WebSocketContext = createContext<IWebSocketContext | undefined>(undefined);

export const useWebSocket = () => {
    const context = useContext(WebSocketContext);
    if (context === undefined) {
        throw new Error("useWebSocket must be used within a WebSocketProvider");
    }
    return context;
};

export const WebSocketProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [socket, setSocket] = useState<Socket | null>(null);
    const token = localStorage.getItem('token')

    useEffect(()=>{
        const newSocket = io(process.env.REACT_APP_API_ADDRESS, {
            reconnection: true,
            reconnectionAttempts: Infinity,
            reconnectionDelay: 2000,
            reconnectionDelayMax: 6000,
            transports: ['websocket'],
            auth: {
                token,
                crm: true
            },
            upgrade: false,
            withCredentials: true
        });

        newSocket.on("connect", () => {
            console.log("🔌 Соединение WebSocket установлено 🔌")
        });

        newSocket.on("disconnect", () => {
            console.log("Соединение потеряно");
        });

        newSocket?.on('update_messages', (data) => {
            if(!data?.author){
                const audio = new Audio(sound);
                audio.play().catch(error => console.log(error))
            }
        })
        
        setSocket(newSocket)
    },[]);

    return (
        <WebSocketContext.Provider value={{ socket }}>
            {children}
        </WebSocketContext.Provider>
    );
};
